export const common = {
  // Navigation
  'nav.features': 'Tính năng',
  'nav.howItWorks': 'Cách hoạt động',
  'nav.pricing': 'Giá cả',
  'nav.faq': 'Câu hỏi thường gặp',
  'nav.aboutUs': 'Về chúng tôi',
  'nav.getStarted': 'Bắt đầu',

  // About Us Section
  'aboutUs.badge': 'Về chúng tôi',
  'aboutUs.title': 'Về chúng tôi',
  'aboutUs.line1': 'Ý tưởng rẻ.',
  'aboutUs.line2': 'Vốn thì không. Thời gian càng không.',
  'aboutUs.paragraph1': 'IdeaOracle.ai được thành lập vì hầu hết các ý tưởng kinh doanh không thất bại do thiếu dũng khí – mà do thiếu sự trung thực. Quá nhiều xác nhận. Quá ít thực tế.',
  'aboutUs.belief1a': 'Chúng tôi không tin vào sự cường điệu.',
  'aboutUs.belief1b': 'Chúng tôi tin vào logic thị trường.',
  'aboutUs.belief2a': 'Chúng tôi không tin vào động lực.',
  'aboutUs.belief2b': 'Chúng tôi tin vào nhu cầu, cạnh tranh và sự khác biệt.',
  'aboutUs.mission1': 'Nhiệm vụ của chúng tôi không phải là làm cho ý tưởng trông đẹp.',
  'aboutUs.mission2': 'Nhiệm vụ của chúng tôi là tiết lộ tính khả thi của chúng.',
  'aboutUs.analysis': 'IdeaOracle.ai phân tích các ngách kinh doanh về cơ chế thị trường cấu trúc, nhu cầu thực tế, cường độ cạnh tranh và tính khả thi. Không cảm xúc. Không lạc quan. Mà tỉnh táo.',
  'aboutUs.failure1': 'Hầu hết các ý tưởng đều thất bại.',
  'aboutUs.failure2': 'Không phải vì người sáng lập bất tài –',
  'aboutUs.failure3': 'mà vì không ai đủ rõ ràng trước đó.',
  'aboutUs.clarity': 'Chúng tôi tồn tại để mang lại sự rõ ràng đó.',
  'aboutUs.value1': 'Khó chịu.',
  'aboutUs.value2': 'Trực tiếp.',
  'aboutUs.value3': 'Nhất quán.',
  'aboutUs.confirm': 'Nếu một ý tưởng có thực chất, chúng tôi xác nhận.',
  'aboutUs.deny': 'Nếu không, chúng tôi cũng nói vậy.',
  'aboutUs.noApplause': 'Không vỗ tay.',
  'aboutUs.noSugarcoating': 'Không tô vẽ.',
  'aboutUs.noTheater': 'Không kịch.',

  // Hero Section
  'hero.badge': 'AI quyết định cho ngách kinh doanh',
  'hero.title1': 'Ý tưởng rẻ.',
  'hero.title2': 'Quyết định sai không rẻ.',
  'hero.subtitle': 'Một AI đánh giá ngách kinh doanh của bạn',
  'hero.subtitleLine2': 'trước khi bạn đầu tư.',
  'hero.cta': 'Kiểm tra ý tưởng',
  'hero.ctaSecondary': 'Cách hoạt động',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Tín dụng mỗi yêu cầu',
  'hero.stat2Value': 'Từ 7',
  'hero.stat2Label': 'Mức đánh giá',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Trung thực và riêng tư',

  // Features Section
  'features.title1': 'Tính năng mạnh mẽ cho',
  'features.title2': 'doanh nghiệp',
  'features.title3': 'hiện đại',
  'features.honestVerdict.title': 'Đánh giá trung thực, không phải điểm hype',
  'features.honestVerdict.description': 'Phán quyết tốt/trung bình/yếu rõ ràng, dựa trên dữ liệu thị trường thực và nghiên cứu đối thủ. Không có điểm 9/10 thiết kế để tâng bốc mọi ý tưởng.',
  'features.fullJourney.title': 'Từ kiểm tra ý tưởng đến Builder Report',
  'features.fullJourney.description': 'Xác thực trong trò chuyện, đi sâu vào phân tích thị trường, xuất Builder Report 25–75 trang với personas, tài chính, go-to-market và pitch deck.',
  'features.multilingual.title': '21 ngôn ngữ, dữ liệu thị trường địa phương',
  'features.multilingual.description': 'Từ doanh nghiệp vừa và nhỏ Thụy Sĩ đến solo founder ở São Paulo — AI trả lời bằng ngôn ngữ của bạn, với nguồn từ thị trường của bạn.',

  // How It Works
  'howItWorks.title': 'Cách hoạt động',
  'howItWorks.subtitle': 'Bốn bước để rõ ràng về ngách kinh doanh của bạn.',
  'howItWorks.step1Title': 'Chọn gói',
  'howItWorks.step1Desc': 'Starter, Pro hoặc Builder - tùy thuộc vào độ sâu đánh giá của bạn.',
  'howItWorks.step2Title': 'Hỏi AI',
  'howItWorks.step2Desc': 'Đặt câu hỏi của bạn về ngách. Mỗi yêu cầu tốn 30 tín dụng.',
  'howItWorks.step3Title': 'Nhận phán quyết trung thực',
  'howItWorks.step3Desc': 'AI đánh giá: Tốt, Trung bình hoặc Xấu. Không tô vẽ.',
  'howItWorks.step4Title': 'Đưa ra quyết định',
  'howItWorks.step4Desc': 'Bây giờ bạn biết liệu có đáng để tiếp tục hay không.',

  // Pricing
  'pricing.title': 'Giá',
  'pricing.subtitle': 'Chọn gói phù hợp với độ sâu đánh giá của bạn.',
  'pricing.yearlyDiscount': 'Đăng ký hàng năm:',
  'pricing.yearlyDiscountValue': 'Giảm -20%',
  'pricing.perMonth': 'mỗi tháng',
  'pricing.selectPlan': 'Chọn gói',
  'pricing.mostPopular': 'Phổ biến nhất',
  'pricing.footer': 'Tất cả giá bằng CHF. Tín dụng chỉ bị trừ cho các phản hồi AI thành công.',
  
  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.description': 'Cho các bài kiểm tra thực tế ban đầu.',
  'pricing.starter.credits': '2.500 tín dụng',
  'pricing.starter.feature1': 'Tạo ý tưởng ngách',
  'pricing.starter.feature2': 'Tinh chỉnh ngách',
  'pricing.starter.feature3': 'Kiểm tra thực tế thị trường',
  'pricing.starter.feature4': 'Đánh giá cạnh tranh',
  'pricing.starter.feature5': 'Đánh giá thời điểm',
  'pricing.starter.feature6': 'Phán quyết trung thực',
  'pricing.starter.feature7': 'Phiên riêng tư',
  'pricing.starter.feature8': 'Lịch sử và xuất',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.description': 'Cho đánh giá sâu hơn.',
  'pricing.pro.credits': '5.000 tín dụng',
  'pricing.pro.feature1': 'Tất cả tính năng Starter',
  'pricing.pro.feature2': 'Nhiều tín dụng hơn cho đánh giá chuyên sâu',
  'pricing.pro.feature3': 'Đề xuất cải thiện',
  'pricing.pro.feature4': 'Ngách thay thế',
  'pricing.pro.feature5': 'Phân tích thị trường chi tiết',
  'pricing.pro.feature6': 'Hỗ trợ ưu tiên',
  'pricing.pro.feature7': 'Bộ lọc nâng cao',
  'pricing.pro.feature8': 'Yêu thích phiên',

  // Builder Plan
  'pricing.builder.name': 'Builder',
  'pricing.builder.description': 'Ý tưởng → Bản tóm tắt nhà phát triển.',
  'pricing.builder.credits': 'Tín dụng không giới hạn',
  'pricing.builder.feature1': 'Tất cả tính năng Pro',
  'pricing.builder.feature2': 'Yêu cầu AI không giới hạn',
  'pricing.builder.feature3': 'Chế độ Builder: Bản tóm tắt nhà phát triển',
  'pricing.builder.feature4': 'Tổng quan dự án có cấu trúc',
  'pricing.builder.feature5': 'Luồng người dùng và chức năng cốt lõi',
  'pricing.builder.feature6': 'Ghi chú kỹ thuật',
  'pricing.builder.feature7': 'Xác định phi mục tiêu',
  'pricing.builder.feature8': 'Giới hạn tốc độ sử dụng hợp lý',
  'pricing.builder.limitNote': 'Giới hạn sử dụng hợp lý',
  'pricing.monthlyReset': 'Đặt lại hàng tháng',

  // Modal
  'pricing.modal.selected': 'đã chọn',
  'pricing.modal.comingSoon': 'Đăng ký và xử lý thanh toán sẽ sớm có sẵn.',
  'pricing.modal.patience': 'Chúng tôi đang làm việc để cung cấp cho bạn trải nghiệm an toàn và liền mạch. Vui lòng kiên nhẫn.',
  'pricing.modal.understood': 'Đã hiểu',

  // FAQ
  'faq.title': 'Câu hỏi thường gặp',
  'faq.subtitle': 'Trả lời trung thực và phê phán.',
  'faq.q1': 'IdeaOracle.ai cụ thể làm gì?',
  'faq.a1': 'IdeaOracle.ai đánh giá ý tưởng kinh doanh và ngách về logic thị trường, nhu cầu thực, cạnh tranh, sự khác biệt và tính khả thi.\nNếu có thực chất, chúng tôi cho thấy cách có thể mài sắc chiến lược.\nNếu không, chúng tôi nói vậy.',
  'faq.q2': 'Bạn có tạo ý tưởng không?',
  'faq.a2': 'Có.\nNhưng không mù quáng.\nChúng tôi phát triển cách tiếp cận dựa trên logic thị trường – không phải động lực hay xu hướng.',
  'faq.q3': 'Bạn có tối ưu hóa mô hình kinh doanh không?',
  'faq.a3': 'Có – nếu có tiềm năng.\nChúng tôi không đánh bóng ảo tưởng.\nChúng tôi làm cho các khái niệm khả thi trở nên bền vững hơn.',
  'faq.q4': 'Điều gì khiến bạn khác biệt với các công cụ AI khác?',
  'faq.a4': 'Các công cụ khác cung cấp cảm hứng.\nChúng tôi cung cấp đánh giá.\nTrọng tâm là chủ nghĩa hiện thực, không phải sự nhiệt tình.',
  'faq.q5': 'Đây có phải là bảo đảm thành công không?',
  'faq.a5': 'Không.\nChúng tôi giảm quyết định sai – chúng tôi không loại bỏ rủi ro.',
  'faq.q6': 'IdeaOracle.ai dành cho ai?',
  'faq.a6': 'Nhà sáng lập trước khi ra mắt\nDoanh nhân trước khi mở rộng\nSide-builder trước khi đầu tư thời gian\nNhà đầu tư trước khi thẩm định\n\nTóm lại: Cho những người muốn sự rõ ràng trước vốn.',
  'faq.q7': 'Nếu tôi chỉ tìm kiếm xác nhận?',
  'faq.a7': 'Thì IdeaOracle.ai không phải công cụ phù hợp.',
  'faq.q8': 'Phân tích trung thực đến mức nào?',
  'faq.a8': 'Trung thực như dữ liệu và cơ chế thị trường cho phép.\nKhông phấn khích. Không nhân nhượng.',
  'faq.q9': 'Bạn có thay thế nghiên cứu thị trường không?',
  'faq.a9': 'Không.\nChúng tôi là đánh giá chiến lược trước – không phải nghiên cứu thị trường đầy đủ.',
  'faq.q10': 'Tại sao không thỏa hiệp?',
  'faq.a10': 'Vì thất bại rất tốn kém.\nSự trung thực thì không.',

  // Footer
  'footer.description': 'Nền tảng này không giúp bạn cảm thấy tốt - mà giúp bạn quyết định đúng.',
  'footer.product': 'Sản phẩm',
  'footer.aiAssistant': 'Trợ lý AI',
  'footer.howItWorks': 'Cách hoạt động',
  'footer.pricing': 'Giá',
  'footer.faq': 'Câu hỏi thường gặp',
  'footer.legal': 'Pháp lý',
  'footer.privacy': 'Quyền riêng tư',
  'footer.terms': 'Điều khoản',
  'footer.imprint': 'Dấu ấn',
  'footer.support': 'Hỗ trợ',
  'footer.contact': 'Liên hệ',
  'footer.documentation': 'Tài liệu',
  'footer.copyright': '© 2025 IdeaOracle.ai. Đã đăng ký bản quyền.',

  // AI Assistant
  'aiAssistant.title': 'Trợ lý AI ngách',
  'aiAssistant.subtitle': 'Câu hỏi về ngách',
  'aiAssistant.welcomeMessage': 'Xin chào! Mô tả ý tưởng của bạn hoặc hỏi tôi về một ngách. Tôi sẽ cho bạn đánh giá rõ ràng và trung thực.',
  'aiAssistant.demoResponse': 'Đây là bản demo. Để nhận đánh giá AI thực, vui lòng đăng ký và chọn gói.',
  'aiAssistant.placeholder': 'Mô tả ý tưởng của bạn...',

  // Header & Sidebar
  'dashboard.header.title': 'Bảng điều khiển',
  'dashboard.sidebar.overview': 'Tổng quan',
  'dashboard.sidebar.newAnalysis': 'Trợ lý AI',
  'dashboard.sidebar.history': 'Lịch sử',
  'dashboard.sidebar.credits': 'Tín dụng',
  'dashboard.sidebar.settings': 'Cài đặt',

  // Dashboard Overview
  'dashboard.overview.welcome': 'Chào mừng trở lại, {{name}}',
  'dashboard.overview.subtitle': 'Đây là tổng quan nhanh về hoạt động của bạn',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Tín dụng còn lại',
  'dashboard.stats.totalAnalyses': 'Tổng số phân tích',
  'dashboard.stats.goodRatings': 'Đánh giá tích cực',
  'dashboard.stats.nextReset': 'Đặt lại tiếp theo trong',
  'dashboard.stats.days': 'ngày',

  // Quick Actions
  'dashboard.quickActions.title': 'Hành động nhanh',
  'dashboard.quickActions.checkNewIdea': 'Kiểm tra ý tưởng',
  'dashboard.quickActions.checkNewIdeaDesc': 'Phân tích ý tưởng kinh doanh hiện có',
  'dashboard.quickActions.generateIdea': 'Tạo ý tưởng',
  'dashboard.quickActions.generateIdeaDesc': 'Tìm ngách có lợi nhuận mới',
  'dashboard.quickActions.builderBriefing': 'Bản tóm tắt Builder',
  'dashboard.quickActions.builderBriefingDesc': 'Biến ý tưởng thành bản tóm tắt sẵn sàng cho nhà phát triển',
  'dashboard.quickActions.premiumOnly': 'Chỉ Builder',

  // Chat Header
  'chat.title': 'Trợ lý AI ngách',
  'chat.subtitle': 'Đặt câu hỏi về ngách. Tôi đánh giá phê phán và trung thực.',
  'chat.creditsLabel': 'Tín dụng',

  // Chat Welcome
  'chat.welcomeTitle': 'Chào mừng đến với Trợ lý AI ngách',
  'chat.welcomeDesc': 'Mô tả ý tưởng của bạn hoặc hỏi về một ngách. Tôi sẽ đánh giá trung thực: Tốt, Trung bình hoặc Xấu.',
  'chat.aiWelcome': 'Xin chào! Mô tả ý tưởng của bạn hoặc hỏi tôi về một ngách. Tôi sẽ cho bạn đánh giá rõ ràng và trung thực.',

  // Chat Suggestions
  'chat.suggestion1': 'Tìm cho tôi một ngách có lợi nhuận.',
  'chat.suggestion2': 'Tôi có một ý tưởng - đánh giá trung thực.',
  'chat.suggestion3': 'Ngách nào có tiềm năng bây giờ?',
  'chat.suggestion4': 'Tinh chỉnh ngách này và làm cho nó cụ thể hơn.',

  // Chat Actions
  'chat.newConversation': 'Cuộc trò chuyện mới',
  'chat.today': 'Hôm nay',
  'chat.yesterday': 'Hôm qua',
  'chat.thisWeek': 'Tuần này',
  'chat.thisMonth': 'Tháng này',
  'chat.older': 'Cũ hơn',
  'chat.messages': 'tin nhắn',
  'chat.renameConversation': 'Đổi tên',
  'chat.deleteConversation': 'Xóa',
  'chat.cancel': 'Hủy',
  'chat.rename': 'Đổi tên',
  'chat.delete': 'Xóa',
  'chat.favorite': 'Thêm yêu thích',
  'chat.unfavorite': 'Xóa yêu thích',
  'chat.searchSessions': 'Tìm kiếm cuộc trò chuyện...',
  'chat.noResults': 'Không tìm thấy kết quả',
  'chat.noSessions': 'Chưa có cuộc trò chuyện',
  'chat.enterNewName': 'Nhập tên mới...',
  'chat.deleteConfirmMessage': 'Bạn có chắc chắn muốn xóa cuộc trò chuyện này không? Hành động này không thể hoàn tác.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Nhập câu hỏi của bạn… (tốn 30 tín dụng)',
  'chat.send': 'Gửi',
  'chat.voice': 'Nói',
  'chat.listeningPlaceholder': 'Tôi đang nghe... Nói ngay bây giờ.',
  'chat.stopListening': 'Dừng ghi âm',
  'chat.recording': 'Đang ghi âm...',
  'chat.speechNotSupported': 'Nhận dạng giọng nói không được trình duyệt của bạn hỗ trợ.',
  'chat.microphonePermissionDenied': 'Quyền truy cập micrô bị từ chối. Vui lòng cho phép truy cập trong cài đặt trình duyệt của bạn.',
  'chat.errorNotEnoughCredits': 'Không đủ tín dụng. Vui lòng nâng cấp gói của bạn hoặc đợi đặt lại tiếp theo.',
  'chat.errorAiFailed': 'Phản hồi AI thất bại. Không có tín dụng bị trừ.',
  'chat.errorRateLimit': 'Quá nhiều yêu cầu. Vui lòng đợi một chút.',

  // Ratings
  'rating.good': 'Tốt',
  'rating.medium': 'Trung bình',
  'rating.bad': 'Xấu',

  // Auth Page
  'auth.branding.headline1': 'Không phải ý tưởng nào cũng tốt.',
  'auth.branding.headline2': 'Chúng tôi nói thật với bạn.',
  'auth.branding.subtitle': 'Một AI quyết định cho ngách kinh doanh. Rõ ràng. Phê phán. Không tô vẽ.',
  'auth.benefits.privacy.title': '100% Riêng tư',
  'auth.benefits.privacy.desc': 'Ý tưởng của bạn hoàn toàn riêng tư và an toàn.',
  'auth.benefits.honest.title': 'AI Trung thực',
  'auth.benefits.honest.desc': 'Không tô vẽ – chỉ phản hồi rõ ràng, phê phán.',
  'auth.benefits.fast.title': 'Kết quả Nhanh',
  'auth.benefits.fast.desc': 'Có được sự rõ ràng về ngách của bạn trong vài phút.',
  'auth.trust.users': 'Người dùng Hoạt động',
  'auth.trust.ideas': 'Ý tưởng Đã phân tích',
  'auth.trust.rating': 'Đánh giá',
  'auth.login.title': 'Đăng nhập',
  'auth.login.headline': 'Chào mừng trở lại',
  'auth.login.subtitle': 'Đăng nhập để tiếp tục hành trình của bạn.',
  'auth.login.forgotPassword': 'Quên mật khẩu?',
  'auth.login.submit': 'Đăng nhập',
  'auth.login.noAccount': 'Chưa có tài khoản?',
  'auth.login.signUp': 'Đăng ký',
  'auth.register.title': 'Đăng ký',
  'auth.register.headline': 'Tạo tài khoản của bạn',
  'auth.register.subtitle': 'Bắt đầu phân tích ý tưởng kinh doanh của bạn ngay hôm nay.',
  'auth.register.submit': 'Tạo Tài khoản',
  'auth.register.hasAccount': 'Đã có tài khoản?',
  'auth.register.signIn': 'Đăng nhập',
  'auth.fields.name': 'Họ và Tên',
  'auth.fields.email': 'Địa chỉ Email',
  'auth.fields.password': 'Mật khẩu',
  'auth.fields.confirmPassword': 'Xác nhận Mật khẩu',
  'auth.fields.selectPlan': 'Chọn gói của bạn',
  'auth.placeholders.name': 'Nhập tên của bạn',
  'auth.placeholders.email': 'Nhập email của bạn',
  'auth.placeholders.password': 'Nhập mật khẩu của bạn',
  'auth.placeholders.confirmPassword': 'Xác nhận mật khẩu của bạn',
  'auth.terms.accept': 'Tôi chấp nhận',
  'auth.terms.terms': 'Điều khoản và Điều kiện',
  'auth.privacy.accept': 'Tôi chấp nhận',
  'auth.privacy.policy': 'Chính sách Bảo mật',
  'auth.errors.nameRequired': 'Tên là bắt buộc',
  'auth.errors.emailRequired': 'Email là bắt buộc',
  'auth.errors.emailInvalid': 'Vui lòng nhập email hợp lệ',
  'auth.errors.passwordRequired': 'Mật khẩu là bắt buộc',
  'auth.errors.passwordLength': 'Mật khẩu phải có ít nhất 8 ký tự',
  'auth.errors.passwordMismatch': 'Mật khẩu không khớp',
  'auth.loading': 'Vui lòng đợi...',
  'auth.or': 'hoặc tiếp tục với',
  'auth.social.google': 'Tiếp tục với Google',
  'auth.social.apple': 'Tiếp tục với Apple',

  // Trial Plan
  'pricing.trial.name': 'Trial',
  'pricing.trial.description': 'Truy cập miễn phí 3 ngày',
  'pricing.trial.credits': '250 tín dụng',
  'pricing.trial.free': 'Miễn phí',
  'pricing.trial.duration': 'Miễn phí trong 3 ngày',
  'pricing.trial.cta': 'Bắt đầu dùng thử miễn phí',
  'pricing.trial.feature1': '250 tín dụng để khám phá AI',
  'pricing.trial.feature2': 'Truy cập đầy đủ trong 3 ngày',
  'pricing.trial.feature3': 'Không cần thẻ tín dụng',
  'pricing.trial.feature4': 'Hủy bất cứ lúc nào',

  // Gold Package
  'pricing.gold.name': 'Gold',
  'pricing.gold.description': '10.000 tín dụng + báo cáo Builder 25 trang',
  'pricing.gold.credits': '10.000 tín dụng',
  'pricing.gold.feature1': '10.000 tín dụng',
  'pricing.gold.feature2': 'Báo cáo Builder 25 trang',
  'pricing.gold.feature3': 'Tất cả tính năng Starter và Pro',
  'pricing.gold.feature4': 'Phân tích thị trường và tóm tắt',
  'pricing.gold.feature5': 'Cơ hội, rủi ro, khuyến nghị',
  'pricing.gold.feature6': 'Tải xuống PDF',
  'pricing.gold.feature7': 'Hỗ trợ',

  // Platinum Package
  'pricing.platinum.name': 'Platinum',
  'pricing.platinum.description': '15.000 tín dụng + báo cáo Builder 100 trang',
  'pricing.platinum.credits': '15.000 tín dụng',
  'pricing.platinum.feature1': '15.000 tín dụng',
  'pricing.platinum.feature2': 'Báo cáo Builder 100 trang',
  'pricing.platinum.feature3': 'Tất cả tính năng Gold',
  'pricing.platinum.feature4': 'Chế độ Builder: tóm tắt cho nhà phát triển',
  'pricing.platinum.feature5': 'Tóm tắt có cấu trúc',
  'pricing.platinum.feature6': 'Phân tích thị trường nâng cao',
  'pricing.platinum.feature7': 'Hỗ trợ',

  // Pricing UI
  'pricing.monthly': 'Hàng tháng',
  'pricing.yearly': 'Hàng năm',
  'pricing.savings': 'tiết kiệm',
  'pricing.billedYearly': 'Thanh toán hàng năm',

  // Hero trial CTA
  'hero.trialTitle': 'Bắt đầu dùng thử miễn phí',
  'hero.creditsLabel': 'Tín dụng',
  'hero.trialTagline': 'Dùng thử trợ lý AI của chúng tôi miễn phí 3 ngày',
  'hero.trialCta': 'Đăng ký & nhận 250 tín dụng',
  'hero.trialNoCard': 'Không cần thẻ tín dụng. Không ràng buộc.',

  // Admin
  'admin.dashboard.tabs.plans': 'Gói',

  // Credit top-up
  'dashboard.credits.topup.button': 'Nạp tín dụng',
  'dashboard.credits.topup.buttonTitle': 'Mua thêm tín dụng mà không cần đổi gói',
  'dashboard.credits.topup.title': 'Nạp tín dụng',
  'dashboard.credits.topup.subtitle': 'CHF 0,15 mỗi tín dụng — không cần đổi gói',
  'dashboard.credits.topup.quickAmounts': 'Chọn nhanh',
  'dashboard.credits.topup.custom': 'Tùy chỉnh',
  'dashboard.credits.topup.totalLabel': 'Tổng',
  'dashboard.credits.topup.creditsLabel': 'Tín dụng',
  'dashboard.credits.topup.confirm': 'Mua ngay',
  'footer.disclaimer': 'Tuyên bố miễn trừ trách nhiệm',
  'legal.backToHome': 'Quay lại trang chủ',
  'legal.lastUpdated': 'Cập nhật lần cuối',
  'legal.allRightsReserved': 'Đã đăng ký bản quyền.',
  'legal.authoritativeNotice': 'Phiên bản bản địa hóa bằng ngôn ngữ của bạn chưa có sẵn. Văn bản tiếng Anh có giá trị pháp lý được hiển thị bên dưới.',
  'legal.translationNotice': 'Đây là bản dịch tham khảo. Bản tiếng Anh là bản gốc có hiệu lực pháp lý.',
};

export default common;
